export const RESET_PASSWORD_USER = "reset-password-user";
export const RESETED_PASSWORD_USER = "reseted-password-user";
export const SEND_AUTHENTICATION_CODE = "send-authentication-code";
export const SENT_AUTHENTICATION_CODE = "sent-authentication-code";
export const REQUEST_USER_CODES = "list-user-codes";
export const LOADED_USER_CODES = "loaded-user-codes";

export function resetPasswordUser(payload) {
    return {
        type: RESET_PASSWORD_USER,
        id: payload.id
    };
}
export function resetedPasswordUser(payload) {
    return {
        type: RESETED_PASSWORD_USER,
        payload: payload
    };
}

export function sendAuthenticationCodeUser(payload) {
    return {
        type: SEND_AUTHENTICATION_CODE,
        payload: payload,
    };
}
export function sentAuthenticationCodeUser(payload) {
    return {
        type: SENT_AUTHENTICATION_CODE,
        payload: payload
    };
}

export function requestUserCodes(payload) {
    return {
        type: REQUEST_USER_CODES,
        payload: payload
    };
}

export function loadedUserCodes(payload) {
    return {
        type: LOADED_USER_CODES,
        payload: payload
    };
}


// WEBPACK FOOTER //
// ./src/actions/users.action.js